export const withdrawalSteps = {
  withdrawalStepsAccount: "Rekening",
  withdrawalStepsAmount: "Bedrag",
  withdrawalStepsWidthdraw: "Onttrek",
  withdrawalStepsError: "Onttrekking het misluk",
  withdrawalStepsErrorDesc_1: "Jy moet ten minste 30% van die gedeponeerde bedrag speel om te onttrek.",
  withdrawalStepsErrorDesc_2: "Jou onttrekking het misluk, kontroleer asseblief jou data of kontak ondersteuning.",
  withdrawalStepsErrorDesc_3: "Jou rekening is nie geverifieer nie. 'n Verifikasie-e-pos is na jou e-pos gestuur.",
  withdrawalStepsErrorDesc_4: "Die bedrag is nie binne die toegelate reeks nie.",
  withdrawalStepsSuccess: "Onttrekking suksesvol",
  withdrawalStepsSuccessMessage: "Jou onttrekking is suksesvol verwerk.",
  emailVerificationSentTitle: "E-posverifikasie",
  emailVerificationSentMessage: "'n Verifikasie-e-pos is na jou e-pos gestuur. Kontroleer asseblief jou inkassie.",
  emailVerificationErrorTitle: "Fout met die stuur van verifikasie",
  emailVerificationErrorMessage:
    "Die verifikasie-e-pos kon nie gestuur word nie. Probeer asseblief weer of kontak ondersteuning.",
  withdrawalStepsNext: "Volgende",
  withdrawalStepsBack: "Terug",
  withdrawalStepsConfirm: "Bevestig",
  withdrawalStepsCancel: "Kanselleer",

  // Inhoud stap 1,
  withdrawalStepsDailyWithdrawal: "Daaglikse onttrekking",
  withdrawalStepsWeeklyWithdrawal: "Weeklikse onttrekking",
  withdrawalStepsWithdrawn: "Onttrek",
  withdrawalStepsDailyRemaining: "Daaglikse oor",
  withdrawalStepsWeeklyRemaining: "Weeklikse oor",
  withdrawalStepsSelectAccount: "Kies jou mobiele betaalrekening",
  withdrawalStepsSelectAccountDesc: "Kies asseblief jou mobiele betaalrekening om met die onttrekking voort te gaan.",
  withdrawalStepsSelectAccountDesc2: "As jy nog nie 'n mobiele betaalrekening opgestel het nie, klik ",
  withdrawalStepsSelectAccountlink: "hier",
  withdrawalStepsSelectTitle: "Bank",
  withdrawalStepsSelectAccount_select: "Kies 'n rekening",

  // stap 1-modale
  withdrawalStepsModalLimitReachedTitle: "Limiet bereik",
  withdrawalDayModalLimitReachedMessage:
    "Jy het die onttrekkingslimiet vir die dag bereik. Probeer asseblief môre weer.",
  withdrawalWeekModalLimitReachedMessage:
    "Jy het die onttrekkingslimiet vir die week bereik. Probeer asseblief volgende week weer.",
  withdrawalStepsModalLimitReachedButton: "Aanvaar",

  // Inhoud stap 2,
  withdrawalSteps_2_Amount: "Voer die bedrag in om te onttrek",
  withdrawalSteps_2_AmountInput: "Voer bedrag in",
  widthdrawalSteps_2_Error: "Ongeldige bedrag",
  withdrawalSteps_2_AmountError: "Voer 'n geldige bedrag in",
  widthdrawalSteps_2_Error2: "Onvoldoende saldo",
  widthdrawalSteps_2_Error3: "Minimum bedrag R 200",
  widthdrawalSteps_2_Error4: "Maksimum bedrag R 8 000 per dag",

  // Inhoud stap 3,
  withdrawalSteps_3_Confirm: "Onttrekkingsbevestiging",
  withdrawalSteps_3_Bank: "Bank ",
  withdrawalSteps_3_PhoneNumber: "Foonnommer",
  withdrawalSteps_3_Amount: "Bedrag",
  withdrawalSteps_3_YouWillWithdraw: "Jy sal onttrek",

  // Voorwaardelike vormvertalings vir onttrekkings
  withdrawalExplanationTitle: "Persoonlike registrasie vereis",
  withdrawalExplanationMessage:
    "Om die onttrekking te voltooi, moet jy jou persoonlike inligting registreer (naam, van, ID en foonnommer). Hierdie inligting word vereis om jou onttrekkings veilig te verwerk.",
  registerAndWithdraw: "Registreer en maak onttrekking",

  // BINANCE-ONTREKKING
  binanceWithdrawalTitle: "Binance-onttrekking",
  binanceWithdrawalNetwork: "Netwerk",
  binanceWithdrawalMinAmount: "Minimum bedrag",
  binanceWithdrawalMaxAmount: "Maksimum bedrag",
  binanceWithdrawalCommission: "Kommissie",
  binanceWithdrawalAmountRequired: "Bedrag word vereis.",
  binanceWithdrawalAddress: "Beursie-adres (TRC20)",
  binanceWithdrawalAddressModal: "Beursie-adres",
  binanceWithdrawalAddressPlaceholder: "Voer beursie-adres in (TRC20)",
  binanceWithdrawalAmount: "Bedrag om te onttrek",
  binanceWithdrawalAmountPlaceholder: "Voer bedrag in om te onttrek",
  binanceWithdrawalConfirmTitle: "Bevestig Binance-onttrekking",
  binanceWithdrawalInputErrorNumber: "Slegs syfers en desimale punt word toegelaat.",
  binanceWithdrawalInputErrorInvalid: "Die bedrag is nie geldig nie.",
  binanceWithdrawalInputErrorMin: "Die minimum bedrag is",
  binanceWithdrawalInputErrorMax: "Die maksimum bedrag is",
  binanceWithdrawalAddressErrorRequired: "Beursie-adres word vereis.",
  binanceWithdrawalAddressErrorStart: "Beursie-adres moet met 'T' begin.",
  binanceWithdrawalAddressErrorLength: "Beursie-adres moet 34 karakters lank wees.",
  binanceWithdrawalSuccessTitle: "Onttrekking suksesvol",
  binanceWithdrawalAmountCorrect: "Korrekte bedrag.",
  binanceWithdrawalAddressCorrect: "Korrekte adres.",
  binanceWithdrawalContinueBtn: "Gaan voort",
  binanceWithdrawalConfirmBtn: "Bevestig",

  // Onttrekking sukses/mislukking-modale toestande
  withdrawalSuccessTitle: "Onttrekking versoek!",
  withdrawalSuccessMessage:
    "Jou onttrekkingsversoek is suksesvol verwerk. Jy sal binnekort die betaling in jou mobiele betaalrekening ontvang.",
  withdrawalSuccessClose: "Sluit",
  withdrawalFailureTitle: "Onttrekking het misluk",
  withdrawalFailureMessage:
    "Ons kon nie jou onttrekkingsversoek verwerk nie. Hersien asseblief die besonderhede en probeer weer.",
  withdrawalFailureRetry: "Probeer weer",
  withdrawalFailureClose: "Sluit",
};
